"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _richTextReactRenderer = require("@contentful/rich-text-react-renderer");

var _contentfulResolveResponse = _interopRequireDefault(require("contentful-resolve-response"));

function renderRichText(_ref) {
  var raw = _ref.raw,
      references = _ref.references;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var richText = JSON.parse(raw); // If no references are given, there is no need to resolve them

  if (!references || !references.length) {
    return (0, _richTextReactRenderer.documentToReactComponents)(richText, options);
  } // Create dummy response so we can use official libraries for resolving the entries


  var dummyResponse = {
    items: [{
      sys: {
        type: "Entry"
      },
      richText: richText
    }],
    includes: {
      Entry: references.filter(function (_ref2) {
        var __typename = _ref2.__typename;
        return __typename !== "ContentfulAsset";
      }).map(function (reference) {
        return _objectSpread(_objectSpread({}, reference), {}, {
          sys: {
            type: "Entry",
            id: reference.contentful_id
          }
        });
      }),
      Asset: references.filter(function (_ref3) {
        var __typename = _ref3.__typename;
        return __typename === "ContentfulAsset";
      }).map(function (reference) {
        return _objectSpread(_objectSpread({}, reference), {}, {
          sys: {
            type: "Asset",
            id: reference.contentful_id
          }
        });
      })
    }
  };
  var resolved = (0, _contentfulResolveResponse.default)(dummyResponse, {
    removeUnresolved: true
  });
  return (0, _richTextReactRenderer.documentToReactComponents)(resolved[0].richText, options);
}

exports.renderRichText = renderRichText;